import { render, staticRenderFns } from "./EditShipmentOtherModal.vue?vue&type=template&id=d7c4dace&"
import script from "./EditShipmentOtherModal.vue?vue&type=script&lang=js&"
export * from "./EditShipmentOtherModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports